import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "medical-data-item",
	templateUrl: "overview-item.component.html",
	styleUrls: ["overview-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class OverviewItemComponent {
	// @ts-expect-error TS2564
	@Input() title: string;
	// @ts-expect-error TS2564
	@Input() icon: string;
	// @ts-expect-error TS2564
	@Input() iconColor: string;
	// @ts-expect-error TS2564
	@Input() value: number;
}
